var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUncheckedCheckbox = function SvgUncheckedCheckbox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    stroke: "#8F8F9B",
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    rx: 2.5,
    stroke: "inherit"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "inherit",
    strokeWidth: 0.058,
    d: "M1.031 1.029h13.942v13.942H1.031z"
  })));
};
export default SvgUncheckedCheckbox;